exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".abs-bottom[data-v-54a312d4]{position:absolute;bottom:17px;left:0;right:0}", ""]);

// exports
